import React from "react";

const LogoElement = () => {
  return (
    <>
      <div className="logo-element">Ibraflex</div>
    </>
  );
};

export default LogoElement;
